<script>
import {
  DOCUMENT_PROJECT_STATUS_START,
  DOCUMENT_PROJECT_STATUS_END,
  DOCUMENT_PROJECT_TYPE_AMENDMENT,
  DOCUMENT_PROJECT_TYPE_REPLACEMENT
} from '@src/api/documents';

export default {
  methods: {
    /**
     * @param {ApiDocumentProject|null} project
     * @returns {string}
     */
    makeProjectText(project) {
      if (!project) {
        return '';
      }

      let statusText =
          project.status === DOCUMENT_PROJECT_STATUS_START
            ? 'Идет'
            : project.status === DOCUMENT_PROJECT_STATUS_END
            ? 'Прошло'
            : '',
        typeText =
          project.type === DOCUMENT_PROJECT_TYPE_AMENDMENT
            ? 'изменения'
            : project.type === DOCUMENT_PROJECT_TYPE_REPLACEMENT
            ? 'взамен'
            : '';

      return `${statusText} публичное обсуждение проекта ${typeText}.`;
    },

    /**
     * @param {ApiDocumentProject|null} project
     * @returns {string}
     */
    makeProjectLinkText(project) {
      return project
        ? project.status === DOCUMENT_PROJECT_STATUS_START
          ? 'Принять участие'
          : 'Посмотреть проект'
        : '';
    }
  }
};
</script>
